/**
 * API — Materias Equivalentes a Revalidar
 *
 * Comunica con los endpoints:
 *   GET  /escolar/materias-revalidar/estudiante/
 *   GET  /escolar/materias-revalidar/candidatas/
 *   POST /escolar/materias-revalidar/guardar/
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders(extra = {}) {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

async function parseJsonOrThrow(res, defaultMsg) {
  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    // sin cuerpo JSON
  }
  if (!res.ok) {
    const msg = (data && (data.error || data.detail)) || `${defaultMsg} (HTTP ${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data;
}

/**
 * Resuelve el estudiante a partir de matricula + campus + ciclo.
 * @param {Object} params - { matricula, id_campus?, ciclo_escolar? }
 */
export async function getEstudianteParaRevalidacion({ matricula, id_campus, ciclo_escolar } = {}) {
  const qs = new URLSearchParams();
  if (matricula) qs.append('matricula', matricula);
  if (id_campus) qs.append('id_campus', id_campus);
  if (ciclo_escolar) qs.append('ciclo_escolar', ciclo_escolar);
  qs.append('_t', Date.now());

  const res = await fetch(
    `${API_BASE}/escolar/materias-revalidar/estudiante/?${qs.toString()}`,
    { headers: getHeaders(), cache: 'no-store' }
  );
  return parseJsonOrThrow(res, 'No se pudo obtener el estudiante');
}

/**
 * Lista las materias del plan de estudios que aun no estan aprobadas
 * (o que ya tienen una revalidacion previa).
 * @param {Object} params - { id_estudiante }
 */
export async function getMateriasCandidatasRevalidacion({ id_estudiante } = {}) {
  const qs = new URLSearchParams();
  qs.append('id_estudiante', id_estudiante);
  qs.append('_t', Date.now());

  const res = await fetch(
    `${API_BASE}/escolar/materias-revalidar/candidatas/?${qs.toString()}`,
    { headers: getHeaders(), cache: 'no-store' }
  );
  return parseJsonOrThrow(res, 'No se pudieron obtener las materias');
}

/**
 * Guarda en bloque las revalidaciones (upsert en EscCardex).
 * @param {Object} payload - { id_estudiante, id_ciclo_escolar?, registros: [...] }
 */
export async function guardarRevalidaciones(payload) {
  const res = await fetch(
    `${API_BASE}/escolar/materias-revalidar/guardar/`,
    {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(payload || {}),
    }
  );
  return parseJsonOrThrow(res, 'No se pudieron guardar las revalidaciones');
}
